import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Target, Eye, Handshake } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { useSettings } from "@/lib/settings";

const VAL_ICONS = [Target, Eye, Handshake, Target, Eye, Handshake];

export default function AboutPage() {
    const settings = useSettings();
    const s = settings || {};
    const bgImg = s.background_image ? resolveImg(s.background_image) : null;
    const values = s.about_values || [];

    return (
        <>
        <title>О компании | AutoTreider</title>
        <meta name="description" content={s.about_text?.substring(0, 160) || ""} />
        <link rel="canonical" href="https://autotreider.eu/about" />
        <meta property="og:title" content="О компании | AutoTreider" />
        <meta property="og:url" content="https://autotreider.eu/about" />
        <div className="min-h-screen pt-16 sm:pt-20" data-testid="about-page">
            <section className="relative h-[30vh] sm:h-[40vh] flex items-center">
                <div className="absolute inset-0">{bgImg && <img src={bgImg} alt="" className="w-full h-full object-cover" loading="eager" />}<div className="absolute inset-0 bg-black/70" /></div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
                    <p className="text-[#0099FF] text-xs uppercase tracking-[0.3em] mb-2 sm:mb-3 font-body">{s.about_subtitle || ""}</p>
                    <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white font-display">{s.company_name || ""}</h1>
                </div>
            </section>
            <section className="py-12 sm:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
                    {s.about_text && (
                        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="max-w-3xl mb-20">
                            <p className="text-zinc-300 text-base leading-relaxed whitespace-pre-wrap font-body">{s.about_text}</p>
                        </motion.div>
                    )}
                    {values.length > 0 && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {values.map((v, i) => {
                                const Icon = VAL_ICONS[i % VAL_ICONS.length];
                                return (
                                    <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-[#09090b] border border-white/5 p-8 hover:border-[#0099FF]/30 transition-all">
                                        <Icon className="w-10 h-10 text-[#0099FF] mb-6" strokeWidth={1.5} />
                                        <h3 className="text-white font-bold text-lg mb-3 font-display">{v.title}</h3>
                                        <p className="text-zinc-500 text-sm leading-relaxed font-body">{v.text}</p>
                                    </motion.div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>
        </div>
        </>
    );
}
